import demoPostSrc11 from '@/assets/images/demo/demo-post-11.png'
import demoPostSrc12 from '@/assets/images/demo/demo-post-12.png'
import demoPostSrc13 from '@/assets/images/demo/demo-post-13.png'
import demoPostSrc14 from '@/assets/images/demo/demo-post-14.png'
import demoPostSrc15 from '@/assets/images/demo/demo-post-15.png'
import demoPostSrc16 from '@/assets/images/demo/demo-post-16.png'
import demoPostSrc17 from '@/assets/images/demo/demo-post-17.png'
import demoPostSrc18 from '@/assets/images/demo/demo-post-18.png'
import {
  makeKolInfo1,
  makeKolInfo2,
  makeKolInfo3,
  makeKolInfo4,
  makeKolInfo5,
  makeKolInfo6,
} from '@/constants/mock-data/kol-info'
import {
  makeCollaborativeItem1,
  makePostContent1,
  makePostContent2,
  makePostContent3,
  makePostContent4,
  makePostContent5,
  makePostContent6,
  makePostContent7,
  makePostContent8,
} from '@/constants/mock-data/post'
import { DEFAULT_PLATFORM_RECORD } from '@/constants/mock-data/predictive-report'
import { SupportedLanguages } from '@/i18n/config'
import {
  PredictiveReportCandidateBasicInfoListResponse,
  PredictiveReportCandidateListResponse,
  PredictiveReportConfigResponse,
  PredictiveReportDetailReportKolsResponse,
  PredictiveReportDetailReportPlatformSubtotalResponse,
  PredictiveReportDetailReportSubtotalResponse,
  PredictiveReportSubtotalResponse,
} from '@/types/schema/api/predictive-report'
import { willingnessToCollaborateSchema } from '@/types/schema/directory/kol-management'
import { KolSchemaModel } from '@/types/schema/kol-schema'
import {
  PredictiveReport,
  PredictiveReportCandidate,
  PredictiveReportCandidatePlatformAnalysis,
  predictiveReportPlatformShortcodeSchema,
} from '@/types/schema/predictive-report'
import { PlatformShortcode } from '@/utils/convert-platform'

type PostContent = {
  thumbnail_url: string
  content: string
  like_count: number
  comment_count: number
  watch_count: number
  mentioned_uuids: string[]
}

const makePostContentList = (locale?: SupportedLanguages): PostContent[] => {
  const postContent1 = makePostContent1(locale)
  const postContent2 = makePostContent2(locale)
  const postContent3 = makePostContent3(locale)
  const postContent4 = makePostContent4(locale)
  const postContent5 = makePostContent5(locale)
  const postContent6 = makePostContent6(locale)
  const postContent7 = makePostContent7(locale)
  const postContent8 = makePostContent8(locale)

  return [
    {
      thumbnail_url: demoPostSrc11,
      content: postContent1,
      like_count: 1000,
      comment_count: 53,
      watch_count: 346784,
      mentioned_uuids: [],
    },
    {
      thumbnail_url: demoPostSrc12,
      content: postContent2,
      like_count: 800,
      comment_count: 23,
      watch_count: 24502,
      mentioned_uuids: [],
    },
    {
      thumbnail_url: demoPostSrc13,
      content: postContent3,
      like_count: 700,
      comment_count: 40,
      watch_count: 36500,
      mentioned_uuids: [],
    },
    {
      thumbnail_url: demoPostSrc14,
      content: postContent4,
      like_count: 920,
      comment_count: 10,
      watch_count: 29500,
      mentioned_uuids: [],
    },
    {
      thumbnail_url: demoPostSrc15,
      content: postContent5,
      like_count: 1000,
      comment_count: 53,
      watch_count: 346784,
      mentioned_uuids: [],
    },
    {
      thumbnail_url: demoPostSrc16,
      content: postContent6,
      like_count: 800,
      comment_count: 23,
      watch_count: 24502,
      mentioned_uuids: [],
    },
    {
      thumbnail_url: demoPostSrc17,
      content: postContent7,
      like_count: 700,
      comment_count: 40,
      watch_count: 36500,
      mentioned_uuids: [],
    },
    {
      thumbnail_url: demoPostSrc18,
      content: postContent8,
      like_count: 920,
      comment_count: 10,
      watch_count: 29500,
      mentioned_uuids: [],
    },
  ]
}

const PREDICTIVE_REPORT_DEMO: PredictiveReport = {
  id: -1,
  name: 'DEMO',
  update_at: '2024/01/21',
  kol_count: 6,
  owner: {
    id: 1,
    name: 'Kolr',
  },
}

const PREDICTIVE_REPORT_CONFIG_DEMO: PredictiveReportConfigResponse = {
  predictive_report_id: PREDICTIVE_REPORT_DEMO.id,
  name: PREDICTIVE_REPORT_DEMO.name,
  owner: PREDICTIVE_REPORT_DEMO.owner,
  customized_tags_names: ['Beauty and Fashion/Beauty Care'],
  platforms: [
    predictiveReportPlatformShortcodeSchema.options[0].enum.ig,
    predictiveReportPlatformShortcodeSchema.options[0].enum.fb,
    predictiveReportPlatformShortcodeSchema.options[0].enum.yt,
    'custom',
  ],
  ig: {
    ...DEFAULT_PLATFORM_RECORD,
    post: true,
    reels: true,
  },
  fb: {
    ...DEFAULT_PLATFORM_RECORD,
    post: true,
    video: false,
    live: false,
    reels: false,
  },
  yt: {
    ...DEFAULT_PLATFORM_RECORD,
    video: true,
    live: false,
    shorts: false,
  },
  start_date: '2025-10-19T16:00:00Z',
  end_date: '2025-11-10T16:00:00Z',
  total_budget: 300000,
  created_at: '2025-01-13T03:16:00.477Z',
  updated_at: '2025-01-14T03:04:13.464Z',
  used_collaborative_item_count: 9,
  kol_count: PREDICTIVE_REPORT_DEMO.kol_count,
  locked_candidate_list: [],
  is_custom_data_completed: true,
  is_data_changed: false,
}

const PREDICTIVE_REPORT_SUBTOTAL_DEMO: PredictiveReportSubtotalResponse = {
  estimate_costs: 288000,
  total_budget: 300000,
  kol_portfolios: {
    level1: 1,
    level2: 0,
    level3: 1,
    level4: 2,
    level5: 0,
    level6: 1,
    level7: 0,
    level8: 0,
  },
  collaborative_items: [
    {
      metadata: {
        is_custom_platform: false,
        platform_name: 'fb',
        is_custom_collaborative_item: false,
        collaborative_item: 'post',
      },
      collaborative_items_count: 2,
    },
    {
      metadata: {
        is_custom_platform: false,
        platform_name: 'fb',
        is_custom_collaborative_item: false,
        collaborative_item: 'story',
      },
      collaborative_items_count: 1,
    },
    {
      metadata: {
        is_custom_platform: false,
        platform_name: 'ig',
        is_custom_collaborative_item: false,
        collaborative_item: 'post',
      },
      collaborative_items_count: 1,
    },
    {
      metadata: {
        is_custom_platform: false,
        platform_name: 'ig',
        is_custom_collaborative_item: false,
        collaborative_item: 'reels',
      },
      collaborative_items_count: 2,
    },
    {
      metadata: {
        is_custom_platform: false,
        platform_name: 'yt',
        is_custom_collaborative_item: false,
        collaborative_item: 'video',
      },
      collaborative_items_count: 1,
    },
  ],
  platform_estimate_reach: [
    {
      platform: 'ig',
      kpi: {
        post: 19007,
        video: 153455,
        custom_value: null,
      },
    },
    {
      platform: 'fb',
      kpi: {
        post: 5909,
        video: null,
        custom_value: null,
      },
    },
    {
      platform: 'yt',
      kpi: {
        post: null,
        video: 502302,
        custom_value: null,
      },
    },
  ],
}

type RecommendReasonMaker = (
  kol: KolSchemaModel,
  locale?: SupportedLanguages,
) => string

const makeRecommendReason1: RecommendReasonMaker = (kol, locale) => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return `${kol.name} is an influential beauty and fashion influencer, sharing insights on elegance, food, and lifestyle that resonate with a broad audience. Her male audience percentage is high, and the 24-34 age group aligns with the target market. Her content has strong potential in the beauty and fashion category, making her a suitable partner for IG platform collaboration with a budget of 300,000.`
    case SupportedLanguages.ja:
      return `${kol.name} は影響力のある美容・ファッションインフルエンサーであり、エレガンス、食事、ライフスタイルに関する見解を発信し、多くの共感を得ています。男性フォロワーの割合が高く、24～34歳の年齢層がターゲット市場のニーズに合致しています。彼女のコンテンツは美容・ファッションカテゴリでの成長の可能性が高く、IGプラットフォームでの300,000の予算によるコラボレーションに適しています。`
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return `${kol.name}是一位具影響力的美容時尚KOL，表達對氣質、食物和生活的看法，能引起大量共鳴。其男性受眾佔比高，且24-34歲的年齡層符合目標市場需求。她的內容在美容時尚類別具有潛力，適合配合300000預算進行IG平臺的合作。`
  }
}

const makeRecommendReason2: RecommendReasonMaker = (kol, locale) => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return `${kol.name} attracts an audience interested in beauty and fashion through her experiences with weight loss and unique life perspectives. Her content focuses on beauty care, aligning with our collaboration needs. With a strong reach and stable engagement, she is well-suited for promoting the 'Demo Report' on the IG platform.`
    case SupportedLanguages.ja:
      return `${kol.name} は、ダイエット経験の共有やライフスタイルに関する独自の視点を通じて、美容やファッションに興味のある多くの視聴者を惹きつけています。彼女のコンテンツは美容ケアを中心としており、私たちのコラボレーションニーズに適合しています。優れたリーチ率と安定したエンゲージメントを持ち、IGプラットフォーム上で「Demo レポート」をプロモーションするのに最適です。`
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return `${kol.name}以其分享減肥經驗及對生活的獨到見解，吸引了許多對美容及時尚有興趣的受眾。其內容涵蓋美容護理，符合我們的合作需求。擁有良好的觸及率及穩定的互動，適合在IG平臺推廣「Demo 報表」。`
  }
}

const makeRecommendReason3: RecommendReasonMaker = (kol, locale) => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return `Recommending ${kol.name} as a collaboration partner due to her influence in the beauty and fashion industry, demonstrated through sharing personal experiences and golf outfit guides. Her audience has a high female ratio, and the age group aligns with the target market, making her an effective choice for reaching relevant consumers and enhancing brand exposure.`
    case SupportedLanguages.ja:
      return `${kol.name} をコラボレーションパートナーとして推薦します。彼女は、個人情報の共有やゴルフファッションガイドなどのコンテンツを通じて、美容・ファッション分野での影響力を発揮しています。彼女のフォロワーの大半は女性であり、年齢層もターゲット市場に適しているため、関連する消費者に効果的にリーチし、ブランドの認知度を向上させることができます。`
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return `推薦${kol.name}作為合作夥伴，因其透過分享個人資訊及高爾夫穿搭指南等內容，展現了其在美妝和時尚領域的影響力。其受眾中，女性佔比高且年齡層符合目標市場需求，能有效觸及相關消費者，提升品牌曝光。`
  }
}

const makeRecommendReason4: RecommendReasonMaker = (kol, locale) => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return `Based on behavioral analysis, ${kol.name} is known for sharing Korean dramas and Japanese travel information. Her audience is 82.28% female, with the primary age range of 35-44, aligning with the target audience in the beauty and fashion industry. Her high engagement and growth rates highlight her strong appeal, making her an ideal partner for this budgeted report.`
    case SupportedLanguages.ja:
      return `行動分析によると、${kol.name} は韓国ドラマや日本の旅行情報を発信することで知られています。彼女のフォロワーの82.28%が女性で、主要な年齢層は35～44歳となっており、美容・ファッション業界のターゲット層に適しています。高いエンゲージメント率と成長率は、彼女が視聴者を強く惹きつける力を持っていることを示しており、この予算レポートのコラボレーションに適しています。`
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return `根據行為分析，${kol.name}以分享韓劇和日本旅遊資訊著稱，其受眾中82.28%為女性，主要年齡層偏向35-44歲，符合美容與時尚領域的目標受眾需求。其高參與率及增長率彰顯其對受眾的吸引力，適合進行該預算報告的合作。`
  }
}

const makeRecommendReason5: RecommendReasonMaker = (kol, locale) => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return `According to ${kol.name}'s behavioral analysis, she frequently participates in events and shares beauty and fashion outfits, especially golf wear and product recommendations. Her audience shows strong interest in beauty and fashion content, aligning with the proposal's needs. Given her strong promotional potential on the platform, she is recommended for collaboration to achieve the report's objectives.`
    case SupportedLanguages.ja:
      return `行動分析によると、${kol.name} は頻繁にイベントに参加し、美容やファッションのスタイリングをシェアしており、特にゴルフファッションや製品の推薦に力を入れています。彼女の視聴者は美容・ファッション関連のコンテンツに対する関心が高く、本提案のニーズに適しています。さらに、プラットフォーム上でのプロモーションの可能性も非常に高いため、レポートの目標達成のためにコラボレーションを推奨します。`
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return `根據${kol.name}的行為分析，她頻繁參與活動並分享美容及時尚穿搭，特別是在高爾夫穿搭及產品推薦方面。其受眾對於美容和時尚內容的關注度高，符合提案需求，且平臺推廣潛力優越，因此推薦與其合作以達成報表目標。`
  }
}

const makeRecommendReason6: RecommendReasonMaker = (kol, locale) => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return `${kol.name} performs exceptionally well on the YT platform, focusing on beauty and fashion while building a strong connection with young female viewers. Her content on body lotion and clothing recommendations aligns with the target market, and her high engagement rate demonstrates strong promotional effectiveness. She is a suitable partner for the 'Demo Report' collaboration with a reasonable budget.`
    case SupportedLanguages.ja:
      return `${kol.name} はYTプラットフォームで優れたパフォーマンスを発揮し、コンテンツは美容とファッションに特化しており、若い女性視聴者と良好な関係を築いています。彼女が紹介するボディクリームやファッションアイテムはターゲット市場のニーズに合致しており、高いエンゲージメント率は優れたプロモーション効果を示しています。予算面でも適しており、「Demo レポート」とのコラボレーションに最適です。`
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return `${kol.name}在YT平臺上表現出色，其內容集中於美妝和時尚，並且與年輕女性觀眾建立良好聯繫。`
  }
}

const makeRecommendReason7: RecommendReasonMaker = (kol, locale) => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return `${kol.name} possesses a strong personal charm, attracting a large young female audience through sharing personal experiences and product recommendations. On the YT platform, 88.37% of her viewers are female, primarily aged 18-24, aligning with the beauty and fashion market. She is an ideal fit for this proposal collaboration.`
    case SupportedLanguages.ja:
      return `${kol.name} は強い個性と魅力を持ち、個人の体験や製品の推薦を通じて、多くの若い女性視聴者を惹きつけています。YTプラットフォームの視聴者の88.37%が女性で、主に18～24歳の年齢層を中心としており、美容・ファッション市場のターゲットに適しています。本提案に最適なコラボレーションパートナーです。`
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return `${kol.name}具備強烈的個人魅力，透過分享個人經歷及產品推薦，吸引了大量年輕女性觀眾。其YT平臺觀眾中，88.37%為女性，主要以18-24歲為主，符合美妝時尚市場需求，適合本提案的合作。`
  }
}

type PredictiveReportCandidateMaker = (
  locale?: SupportedLanguages,
) => PredictiveReportCandidate

export const makePredictiveReportCandidateInstagramDemo1: PredictiveReportCandidateMaker =
  (locale) => {
    const kolInfo = makeKolInfo1(locale)
    const postContentList = makePostContentList(locale)

    return {
      predictive_report_kol_id: 164,
      name: kolInfo.name,
      uuid: kolInfo.id,
      platform: 'ig',
      is_selected: true,
      collaborative_items: [
        {
          predictive_report_kol_collaborative_item_id: 243,
          metadata: {
            is_custom_platform: false,
            platform_name: 'ig',
            is_custom_collaborative_item: false,
            collaborative_item: 'reels',
          },
          collaborative_items_count: 1,
          cooperation_fee: 31000,
        },
      ],
      total_cooperation_fee: 31000,
      kpi: {
        follower_count: 33425,
        engagement_rate: 0.0181937172774869,
        engagement_rate_performance: null,
        view_rate: 0.1824981301421092,
        view_rate_performance: null,
        follow_count_growth_rate: 0.0023991602938622236,
        follow_count_growth_rate_performance: null,
        image_estimated_reach_count: 4103,
        video_estimated_reach_count: 3621,
        main_audience: {
          main_gender: {
            code: 'Male',
            weight: 0.548626,
          },
          main_age: {
            code: '25-34',
            weight: 0.525189,
          },
        },
        score: 78,
      },
      posts: [
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '302805759',
          post_id: 'DBYtXXvvrDj',
          ig_post_id: '3395088039888124616',
          title: '',
          link: '',
          ...postContentList[0],
        },
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '8717007006',
          post_id: 'DBVk_AyPM6b',
          ig_post_id: '3387841904665942872',
          title: '',
          link: '',
          ...postContentList[1],
        },
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '3451650438',
          post_id: 'DBLutKISS_O',
          ig_post_id: '3337806419120247453',
          title: '',
          link: '',
          ...postContentList[2],
        },
      ],
      recommend_reason: makeRecommendReason1(kolInfo, locale),
      willingness_to_collaborate:
        willingnessToCollaborateSchema.enum.to_be_confirmed,
      note: '-',
      customized_tags: [],
      follower_level: 'level3',
    }
  }

export const makePredictiveReportCandidateInstagramDemo2: PredictiveReportCandidateMaker =
  (locale) => {
    const kolInfo = makeKolInfo2(locale)
    const postContentList = makePostContentList(locale)

    return {
      predictive_report_kol_id: 158,
      name: kolInfo.name,
      uuid: kolInfo.id,
      platform: 'ig',
      is_selected: true,
      collaborative_items: [
        {
          predictive_report_kol_collaborative_item_id: 234,
          metadata: {
            is_custom_platform: false,
            platform_name: 'ig',
            is_custom_collaborative_item: false,
            collaborative_item: 'reels',
          },
          collaborative_items_count: 1,
          cooperation_fee: 51500,
        },
      ],
      total_cooperation_fee: 51500,
      kpi: {
        follower_count: 62607,
        engagement_rate: 0.0037184340409219,
        engagement_rate_performance: null,
        view_rate: 0.2388081017063493,
        view_rate_performance: null,
        follow_count_growth_rate: -0.005685698240995407,
        follow_count_growth_rate_performance: null,
        image_estimated_reach_count: 2267,
        video_estimated_reach_count: 9816,
        main_audience: {
          main_gender: {
            code: 'Male',
            weight: 0.513214,
          },
          main_age: {
            code: '25-34',
            weight: 0.538011,
          },
        },
        score: 80,
      },
      posts: [
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '302805759',
          post_id: 'DBYtXXvvrDj',
          ig_post_id: '3395088039888124616',
          title: '',
          link: '',
          ...postContentList[3],
        },
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '8717007006',
          post_id: 'DBVk_AyPM6b',
          ig_post_id: '3387841904665942872',
          title: '',
          link: '',
          ...postContentList[4],
        },
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '3451650438',
          post_id: 'DBLutKISS_O',
          ig_post_id: '3337806419120247453',
          title: '',
          link: '',
          ...postContentList[5],
        },
      ],
      recommend_reason: makeRecommendReason2(kolInfo, locale),
      willingness_to_collaborate:
        willingnessToCollaborateSchema.enum.to_be_confirmed,
      note: '-',
      customized_tags: [],
      follower_level: 'level4',
    }
  }

export const makePredictiveReportCandidateInstagramDemo3: PredictiveReportCandidateMaker =
  (locale) => {
    const kolInfo = makeKolInfo3(locale)
    const postContentList = makePostContentList(locale)

    return {
      predictive_report_kol_id: 177,
      name: kolInfo.name,
      uuid: kolInfo.id,
      platform: 'ig',
      is_selected: true,
      collaborative_items: [
        {
          predictive_report_kol_collaborative_item_id: 253,
          metadata: {
            is_custom_platform: false,
            platform_name: 'ig',
            is_custom_collaborative_item: false,
            collaborative_item: 'post',
          },
          collaborative_items_count: 1,
          cooperation_fee: 51500,
        },
      ],
      total_cooperation_fee: 51500,
      kpi: {
        follower_count: 70828,
        engagement_rate: 0.056024554453848,
        engagement_rate_performance: null,
        view_rate: 2.83720723846098,
        view_rate_performance: null,
        follow_count_growth_rate: 0.10159263759851456,
        follow_count_growth_rate_performance: null,
        image_estimated_reach_count: 12637,
        video_estimated_reach_count: 140018,
        main_audience: {
          main_gender: {
            code: 'Female',
            weight: 0.5375661375661376,
          },
          main_age: {
            code: '25-34',
            weight: 0.5512731717254022,
          },
        },
        score: 86,
      },
      posts: [
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '302805759',
          post_id: 'DBYtXXvvrDj',
          ig_post_id: '3395088039888124616',
          title: '',
          link: '',
          ...postContentList[6],
        },
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '8717007006',
          post_id: 'DBVk_AyPM6b',
          ig_post_id: '3387841904665942872',
          title: '',
          link: '',
          ...postContentList[7],
        },
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '3451650438',
          post_id: 'DBLutKISS_O',
          ig_post_id: '3337806419120247453',
          title: '',
          link: '',
          ...postContentList[0],
        },
      ],
      recommend_reason: makeRecommendReason3(kolInfo, locale),
      willingness_to_collaborate:
        willingnessToCollaborateSchema.enum.to_be_confirmed,
      note: '-',
      customized_tags: [],
      follower_level: 'level4',
    }
  }

export const makePredictiveReportCandidateFacebookDemo1: PredictiveReportCandidateMaker =
  (locale) => {
    const kolInfo = makeKolInfo4(locale)
    const postContentList = makePostContentList(locale)

    return {
      predictive_report_kol_id: 178,
      name: kolInfo.name,
      uuid: kolInfo.id,
      platform: 'fb',
      is_selected: true,
      collaborative_items: [
        {
          predictive_report_kol_collaborative_item_id: 254,
          metadata: {
            is_custom_platform: false,
            platform_name: 'fb',
            is_custom_collaborative_item: false,
            collaborative_item: 'post',
          },
          collaborative_items_count: 1,
          cooperation_fee: 5500,
        },
      ],
      total_cooperation_fee: 5500,
      kpi: {
        follower_count: 7334,
        engagement_rate: 0.0687101172620671,
        engagement_rate_performance: null,
        view_rate: 0.9761112626124898,
        view_rate_performance: null,
        follow_count_growth_rate: 0.07948189228773117,
        follow_count_growth_rate_performance: null,
        image_estimated_reach_count: 5202,
        video_estimated_reach_count: null,
        main_audience: {
          main_gender: {
            code: 'Female',
            weight: 0.8227848101265823,
          },
          main_age: {
            code: '35-44',
            weight: 0.3953934740882917,
          },
        },
        score: 85,
      },
      posts: [
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '302805759',
          post_id: 'DBYtXXvvrDj',
          ig_post_id: '3395088039888124616',
          title: '',
          link: '',
          ...postContentList[0],
        },
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '8717007006',
          post_id: 'DBVk_AyPM6b',
          ig_post_id: '3387841904665942872',
          title: '',
          link: '',
          ...postContentList[1],
        },
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '3451650438',
          post_id: 'DBLutKISS_O',
          ig_post_id: '3337806419120247453',
          title: '',
          link: '',
          ...postContentList[2],
        },
      ],
      recommend_reason: makeRecommendReason4(kolInfo, locale),
      willingness_to_collaborate:
        willingnessToCollaborateSchema.enum.to_be_confirmed,
      note: '-',
      customized_tags: [],
      follower_level: 'level1',
    }
  }

export const makePredictiveReportCandidateFacebookDemo2: PredictiveReportCandidateMaker =
  (locale) => {
    const kolInfo = makeKolInfo3(locale)
    const postContentList = makePostContentList(locale)

    return {
      predictive_report_kol_id: 176,
      name: kolInfo.name,
      uuid: kolInfo.id,
      platform: 'fb',
      is_selected: true,
      collaborative_items: [
        {
          predictive_report_kol_collaborative_item_id: 252,
          metadata: {
            is_custom_platform: false,
            platform_name: 'fb',
            is_custom_collaborative_item: false,
            collaborative_item: 'post',
          },
          collaborative_items_count: 1,
          cooperation_fee: 5500,
        },
        {
          predictive_report_kol_collaborative_item_id: 636,
          metadata: {
            is_custom_platform: false,
            platform_name: 'fb',
            is_custom_collaborative_item: false,
            collaborative_item: 'story',
          },
          collaborative_items_count: 1,
          cooperation_fee: 500,
        },
      ],
      total_cooperation_fee: 6000,
      kpi: {
        follower_count: 11143,
        engagement_rate: 0.0276952971060014,
        engagement_rate_performance: null,
        view_rate: 5.061759624876604,
        view_rate_performance: null,
        follow_count_growth_rate: 0.2978103756904602,
        follow_count_growth_rate_performance: null,
        image_estimated_reach_count: 707,
        video_estimated_reach_count: null,
        main_audience: {
          main_gender: null,
          main_age: null,
        },
        score: 71,
      },
      posts: [
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '302805759',
          post_id: 'DBYtXXvvrDj',
          ig_post_id: '3395088039888124616',
          title: '',
          link: '',
          ...postContentList[3],
        },
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '8717007006',
          post_id: 'DBVk_AyPM6b',
          ig_post_id: '3387841904665942872',
          title: '',
          link: '',
          ...postContentList[4],
        },
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '3451650438',
          post_id: 'DBLutKISS_O',
          ig_post_id: '3337806419120247453',
          title: '',
          link: '',
          ...postContentList[5],
        },
      ],
      recommend_reason: makeRecommendReason5(kolInfo, locale),
      willingness_to_collaborate:
        willingnessToCollaborateSchema.enum.to_be_confirmed,
      note: '-',
      customized_tags: [],
      follower_level: 'level2',
    }
  }

export const makePredictiveReportCandidateYoutubeDemo1: PredictiveReportCandidateMaker =
  (locale) => {
    const kolInfo = makeKolInfo5(locale)
    const postContentList = makePostContentList(locale)

    return {
      predictive_report_kol_id: 175,
      name: kolInfo.name,
      uuid: kolInfo.id,
      platform: 'yt',
      is_selected: true,
      collaborative_items: [
        {
          predictive_report_kol_collaborative_item_id: 251,
          metadata: {
            is_custom_platform: false,
            platform_name: 'yt',
            is_custom_collaborative_item: false,
            collaborative_item: 'video',
          },
          collaborative_items_count: 1,
          cooperation_fee: 142500,
        },
      ],
      total_cooperation_fee: 142500,
      kpi: {
        follower_count: 301000,
        engagement_rate: 0.0036653312487786,
        engagement_rate_performance: null,
        view_rate: 0.1294625757279656,
        view_rate_performance: null,
        follow_count_growth_rate: 0.023255813866853714,
        follow_count_growth_rate_performance: null,
        image_estimated_reach_count: null,
        video_estimated_reach_count: 502302,
        main_audience: {
          main_gender: {
            code: 'Female',
            weight: 0.918578,
          },
          main_age: {
            code: '18-24',
            weight: 0.636919,
          },
        },
        score: 88,
      },
      posts: [
        {
          platform_type: PlatformShortcode.YouTube,
          crawler_id: '302805759',
          post_id: 'DBYtXXvvrDj',
          ig_post_id: '3395088039888124616',
          title: '',
          link: '',
          ...postContentList[0],
        },
        {
          platform_type: PlatformShortcode.YouTube,
          crawler_id: '8717007006',
          post_id: 'DBVk_AyPM6b',
          ig_post_id: '3387841904665942872',
          title: '',
          link: '',
          ...postContentList[1],
        },
        {
          platform_type: PlatformShortcode.YouTube,
          crawler_id: '3451650438',
          post_id: 'DBLutKISS_O',
          ig_post_id: '3337806419120247453',
          title: '',
          link: '',
          ...postContentList[2],
        },
      ],
      recommend_reason: makeRecommendReason6(kolInfo, locale),
      willingness_to_collaborate: willingnessToCollaborateSchema.enum.willing,
      note: '-',
      customized_tags: [],
      follower_level: 'level6',
    }
  }

export const makePredictiveReportCandidateYoutubeDemo2: PredictiveReportCandidateMaker =
  (locale) => {
    const kolInfo = makeKolInfo6(locale)
    const postContentList = makePostContentList(locale)

    return {
      predictive_report_kol_id: 174,
      name: kolInfo.name,
      uuid: kolInfo.id,
      platform: 'yt',
      is_selected: false,
      collaborative_items: [
        {
          predictive_report_kol_collaborative_item_id: 250,
          metadata: {
            is_custom_platform: false,
            platform_name: 'yt',
            is_custom_collaborative_item: false,
            collaborative_item: 'video',
          },
          collaborative_items_count: 1,
          cooperation_fee: 190000,
        },
      ],
      total_cooperation_fee: 190000,
      kpi: {
        follower_count: 589000,
        engagement_rate: 0.003503961516695,
        engagement_rate_performance: null,
        view_rate: 0.1433585172608942,
        view_rate_performance: null,
        follow_count_growth_rate: 0.003395585808902979,
        follow_count_growth_rate_performance: null,
        image_estimated_reach_count: null,
        video_estimated_reach_count: 1079201,
        main_audience: {
          main_gender: {
            code: 'Female',
            weight: 0.883695,
          },
          main_age: {
            code: '18-24',
            weight: 0.638316,
          },
        },
        score: 91,
      },
      posts: [
        {
          platform_type: PlatformShortcode.YouTube,
          crawler_id: '302805759',
          post_id: 'DBYtXXvvrDj',
          ig_post_id: '3395088039888124616',
          title: '',
          link: '',
          ...postContentList[3],
        },
        {
          platform_type: PlatformShortcode.YouTube,
          crawler_id: '8717007006',
          post_id: 'DBVk_AyPM6b',
          ig_post_id: '3387841904665942872',
          title: '',
          link: '',
          ...postContentList[4],
        },
        {
          platform_type: PlatformShortcode.YouTube,
          crawler_id: '3451650438',
          post_id: 'DBLutKISS_O',
          ig_post_id: '3337806419120247453',
          title: '',
          link: '',
          ...postContentList[5],
        },
      ],
      recommend_reason: makeRecommendReason7(kolInfo, locale),
      willingness_to_collaborate:
        willingnessToCollaborateSchema.enum.to_be_confirmed,
      note: '-',
      customized_tags: [],
      follower_level: 'level7',
    }
  }

export const makePredictiveReportCandidateCustomDemo1: PredictiveReportCandidateMaker =
  (locale) => {
    const kolInfo = makeKolInfo1(locale)
    const collaborativeItem1 = makeCollaborativeItem1(locale)

    return {
      predictive_report_kol_id: 485,
      name: kolInfo.name,
      uuid: kolInfo.id,
      platform: 'custom',
      is_selected: false,
      collaborative_items: [
        {
          predictive_report_kol_collaborative_item_id: 635,
          metadata: {
            is_custom_platform: true,
            platform_name: 'Dcard',
            is_custom_collaborative_item: true,
            collaborative_item: collaborativeItem1,
          },
          collaborative_items_count: 1,
          cooperation_fee: 5000,
        },
      ],
      total_cooperation_fee: 5000,
      kpi: {
        follower_count: null,
        engagement_rate: null,
        engagement_rate_performance: null,
        view_rate: null,
        view_rate_performance: null,
        follow_count_growth_rate: null,
        follow_count_growth_rate_performance: null,
        image_estimated_reach_count: null,
        video_estimated_reach_count: null,
        main_audience: {
          main_gender: null,
          main_age: null,
        },
        score: null,
      },
      posts: [],
      recommend_reason: null,
      willingness_to_collaborate:
        willingnessToCollaborateSchema.enum.to_be_confirmed,
      note: '-',
      customized_tags: [],
      follower_level: null,
    }
  }

export const makePredictiveReportCandidateListInstagramDemo = (
  locale?: SupportedLanguages,
): PredictiveReportCandidateListResponse => {
  const candidateInstagramList = [
    makePredictiveReportCandidateInstagramDemo1(locale),
    makePredictiveReportCandidateInstagramDemo2(locale),
    makePredictiveReportCandidateInstagramDemo3(locale),
  ]

  return {
    data: {
      list: candidateInstagramList,
      total_selected: candidateInstagramList.filter(
        (candidate) => candidate.is_selected,
      ).length,
    },
    total: candidateInstagramList.length,
    page: 1,
    per_page: 10,
    total_page: 1,
  }
}

export const makePredictiveReportCandidateListFacebookDemo = (
  locale?: SupportedLanguages,
): PredictiveReportCandidateListResponse => {
  const candidateList = [
    makePredictiveReportCandidateFacebookDemo1(locale),
    makePredictiveReportCandidateFacebookDemo2(locale),
  ]

  return {
    data: {
      list: candidateList,
      total_selected: candidateList.filter((candidate) => candidate.is_selected)
        .length,
    },
    total: candidateList.length,
    page: 1,
    per_page: 10,
    total_page: 1,
  }
}

export const makePredictiveReportCandidateListYoutubeDemo = (
  locale?: SupportedLanguages,
): PredictiveReportCandidateListResponse => {
  const candidateList = [makePredictiveReportCandidateYoutubeDemo1(locale)]

  return {
    data: {
      list: candidateList,
      total_selected: candidateList.filter((candidate) => candidate.is_selected)
        .length,
    },
    total: candidateList.length,
    page: 1,
    per_page: 10,
    total_page: 1,
  }
}

export const makePredictiveReportCandidateListCustomDemo = (
  locale?: SupportedLanguages,
): PredictiveReportCandidateListResponse => {
  const candidateList = [makePredictiveReportCandidateCustomDemo1(locale)]

  return {
    data: {
      list: candidateList,
      total_selected: candidateList.filter((candidate) => candidate.is_selected)
        .length,
    },
    total: candidateList.length,
    page: 1,
    per_page: 10,
    total_page: 1,
  }
}

export const makePredictiveReportCandidateListAllDemo = (
  locale?: SupportedLanguages,
): PredictiveReportCandidateListResponse => {
  const igCandidateList = makePredictiveReportCandidateListInstagramDemo(locale)
  const fbCandidateList = makePredictiveReportCandidateListFacebookDemo(locale)
  const ytCandidateList = makePredictiveReportCandidateListYoutubeDemo(locale)
  const customCandidateList =
    makePredictiveReportCandidateListCustomDemo(locale)

  return {
    ...igCandidateList,
    data: {
      list: [
        ...igCandidateList.data.list,
        ...fbCandidateList.data.list,
        ...ytCandidateList.data.list,
        ...customCandidateList.data.list,
      ],
      total_selected:
        igCandidateList.data.total_selected +
        fbCandidateList.data.total_selected +
        ytCandidateList.data.total_selected +
        customCandidateList.data.total_selected,
    },
  }
}

export const makePredictiveReportCandidateBasicInfoListDemo = (
  locale?: SupportedLanguages,
): PredictiveReportCandidateBasicInfoListResponse => {
  const candidateList = makePredictiveReportCandidateListAllDemo(locale)

  return {
    kols: Object.values(
      candidateList.data.list
        .filter((candidate) => candidate.is_selected)
        .reduce((acc, candidate) => {
          acc[candidate.uuid] = {
            kol_uuid: candidate.uuid,
            name: candidate.name,
          }
          return acc
        }, {}),
    ),
  }
}

export const makePredictiveReportAiSummary = (
  locale?: SupportedLanguages,
): string => {
  switch (locale) {
    case SupportedLanguages.enUS:
      return 'The primary objective of this report is to evaluate the collaboration effectiveness of five influencers on social media platforms, including Instagram, YouTube, and Facebook. The analysis covers six major collaboration content types, with a total budget of 300,000 and an actual expenditure of 287,500, indicating efficient budget utilization.\n\nKey data highlights varying interaction rates across different activity types, with a view rate of 66.69%, demonstrating the strong appeal of video content. While the share rate and comment rate are relatively low, there is potential for overall engagement improvement. Notably, certain content has shown significant value in word-of-mouth marketing (WOMM), indicating strong brand exposure benefits.\n\nObservations suggest that some influencers achieve higher interaction and view counts, implying that their creative content strategies are more engaging. This insight can serve as an important reference for selecting future collaboration partners.\n\nIt is recommended to increase the proportion of short videos or live content in future campaigns and explore more interactive content formats to enhance engagement and conversion rates, ultimately strengthening brand influence and exposure.'
    case SupportedLanguages.ja:
      return '本レポートの主な目的は、Instagram、YouTube、Facebook を含むソーシャルメディアプラットフォームでの 5 人のインフルエンサーとのコラボレーション効果を評価することです。分析対象は 6 つの主要なコラボレーションコンテンツであり、総予算は 30 万円、実際の支出は 28.75 万円で、予算が効果的に活用されていることを示しています。\n\n主要データによると、各アクティビティタイプのエンゲージメント率は異なり、視聴率は 66.69% に達しており、動画コンテンツの高い魅力を示しています。一方で、シェア率やコメント率は比較的低く、全体的なエンゲージメントの向上の余地があります。特に、一部のコンテンツは 口コミマーケティング（WOMM） において非常に高い価値を示しており、ブランドの露出効果の潜在的なメリットが確認されました。\n\n観察の結果、一部のインフルエンサーはより高いエンゲージメント率や視聴数を獲得しており、彼らのクリエイティブなコンテンツ戦略がより魅力的であることを示唆しています。この点は、今後のコラボレーションパートナーの選定において重要な参考となります。\n\n今後は、ショート動画やライブ配信コンテンツの割合を増やすこと を検討し、より多様なインタラクティブコンテンツを導入することで、エンゲージメントやコンバージョン率の向上を目指し、ブランドの影響力と露出度を強化することを推奨します。'
    case SupportedLanguages.zhTW:
    case SupportedLanguages.ach:
    default:
      return '該報告的主要目的是評估五位影響者在社交媒體平臺（包括Instagram, YouTube, 和Facebook）上的合作效果。共涉及六項主合作內容，總預算為30萬元，實際支出為28.75萬元，顯示預算有效利用。\n\n關鍵數據指出，各項活動類型的互動率表現各異，觀看率達66.69%，顯示影片型內容的吸引力高。雖然分享率和評論率偏低，整體互動有進一步提高的潛力。值得注意的是，某些內容在口碑行銷（WOMM）方面展現了極高的價值，顯示品牌曝光的潛在效益。\n\n觀察中發現，某些影響者能夠獲得較高的互動和觀看次數，暗示其創意內容策略更具吸引力。這一點可作為未來選擇合作對象的重要依據。\n\n建議未來考慮提高短影片或直播內容的比例，並探索多樣化的互動型內容，以提升參與度和轉換率，從而加強品牌影響力與曝光率。'
  }
}

export const makePredictiveReportDetailReportSubtotalDemo = (
  locale?: SupportedLanguages,
): PredictiveReportDetailReportSubtotalResponse => {
  const summary = makePredictiveReportAiSummary(locale)

  return {
    estimate_value: {
      budget: 300000,
      cost: 288000,
      cpe: 42.84439155013389,
      cpv: 0.8874290133823063,
      cpev: 0.8694208389307331,
      womm: 1525435.2740197298,
    },
    estimate_effectiveness: {
      like_count: 6347,
      click_count: 0,
      comment_count: 351,
      share_count: 20,
      view_count: 324533,
      reach_count: 680673,
      engagement_count: 6722,
    },
    summary: [summary],
  }
}

const PREDICTIVE_REPORT_DETAIL_REPORT_PLATFORM_SUBTOTAL_INSTAGRAM_DEMO: PredictiveReportDetailReportPlatformSubtotalResponse =
  {
    estimate_value: {
      cpe: 27.870216306156404,
      cpv: 0.6035927280589539,
      cpev: 0.5907976650265419,
      womm: 907349.2289915967,
    },
    estimate_effectiveness: {
      like_count: 4715,
      click_count: 0,
      comment_count: 90,
      share_count: 0,
      view_count: 222004,
      reach_count: 172462,
      engagement_count: 4808,
      view_rate: 1.3304806424547524,
      reach_rate: 1.0335730552559033,
      engagement_rate: 0.028814575092892245,
    },
  }

const PREDICTIVE_REPORT_DETAIL_REPORT_PLATFORM_SUBTOTAL_FACEBOOK_DEMO: PredictiveReportDetailReportPlatformSubtotalResponse =
  {
    estimate_value: {
      cpe: 14.180024660912453,
      cpv: 0.1809285568194333,
      cpev: 0.17864910209407817,
      womm: 493387.6920869565,
    },
    estimate_effectiveness: {
      like_count: 770,
      click_count: 0,
      comment_count: 21,
      share_count: 20,
      view_count: 63561,
      reach_count: 5909,
      engagement_count: 811,
      view_rate: 2.1458811613774476,
      reach_rate: 0.19949358541525997,
      engagement_rate: 0.02738014854827819,
    },
  }

const PREDICTIVE_REPORT_DETAIL_REPORT_PLATFORM_SUBTOTAL_YOUTUBE_DEMO: PredictiveReportDetailReportPlatformSubtotalResponse =
  {
    estimate_value: {
      cpe: 129.19310970081597,
      cpv: 3.6568466433997124,
      cpev: 3.5561877667140824,
      womm: 124698.35294117649,
    },
    estimate_effectiveness: {
      like_count: 862,
      click_count: 0,
      comment_count: 240,
      share_count: 0,
      view_count: 38968,
      reach_count: 502302,
      engagement_count: 1103,
      view_rate: 0.12946179401993355,
      reach_rate: 1.6687774086378737,
      engagement_rate: 0.003664451827242525,
    },
  }

const PREDICTIVE_REPORT_DETAIL_REPORT_PLATFORM_SUBTOTAL_CUSTOM_DEMO: PredictiveReportDetailReportPlatformSubtotalResponse =
  {
    estimate_value: {
      cpe: 0,
      cpv: 0,
      cpev: 0,
      womm: 0,
    },
    estimate_effectiveness: {
      like_count: 0,
      click_count: 0,
      comment_count: 0,
      share_count: 0,
      view_count: 0,
      reach_count: 0,
      engagement_count: 0,
      view_rate: 0,
      reach_rate: 0,
      engagement_rate: 0,
    },
  }

export const makePredictiveReportCandidatePlatformAnalysisInstagramDemo1 = (
  locale?: SupportedLanguages,
): PredictiveReportCandidatePlatformAnalysis => {
  const candidate = makePredictiveReportCandidateInstagramDemo1(locale)

  return {
    uuid: candidate.uuid,
    predictive_report_kol_id: candidate.predictive_report_kol_id,
    name: candidate.name,
    collaborative_items: candidate.collaborative_items,
    kpi: {
      estimated_avg_view_rate: 2.8371971536680407,
      estimated_click_count: 0,
      estimated_comment_count: 42,
      estimated_engagement_count: 3968,
      estimated_engagement_rate: 0.056023041734907096,
      estimated_like_count: 3925,
      estimated_reach_count: 152655,
      estimated_reach_rate: 2.1552916925509686,
      estimated_share_count: 0,
      estimated_view_count: 200953,
    },
  }
}

export const makePredictiveReportCandidatePlatformAnalysisInstagramDemo2 = (
  locale?: SupportedLanguages,
): PredictiveReportCandidatePlatformAnalysis => {
  const candidate = makePredictiveReportCandidateInstagramDemo2(locale)

  return {
    uuid: candidate.uuid,
    predictive_report_kol_id: candidate.predictive_report_kol_id,
    name: candidate.name,
    collaborative_items: candidate.collaborative_items,
    kpi: {
      estimated_like_count: 565,
      estimated_comment_count: 42,
      estimated_share_count: 0,
      estimated_view_count: 6100,
      estimated_engagement_count: 608,
      estimated_reach_count: 7724,
      estimated_click_count: 0,
      estimated_avg_view_rate: 0.1824981301421092,
      estimated_reach_rate: 0.23108451757666418,
      estimated_engagement_rate: 0.01818997756170531,
    },
  }
}

export const makePredictiveReportCandidatePlatformAnalysisInstagramDemo3 = (
  locale?: SupportedLanguages,
): PredictiveReportCandidatePlatformAnalysis => {
  const candidate = makePredictiveReportCandidateInstagramDemo3(locale)

  return {
    uuid: candidate.uuid,
    predictive_report_kol_id: candidate.predictive_report_kol_id,
    name: candidate.name,
    collaborative_items: candidate.collaborative_items,
    kpi: {
      estimated_like_count: 225,
      estimated_comment_count: 6,
      estimated_share_count: 0,
      estimated_view_count: 14951,
      estimated_engagement_count: 232,
      estimated_reach_count: 12083,
      estimated_click_count: 0,
      estimated_avg_view_rate: 0.23880716213841902,
      estimated_reach_rate: 0.19299758812912293,
      estimated_engagement_rate: 0.0037056559170699764,
    },
  }
}

export const makePredictiveReportCandidatePlatformAnalysisFacebookDemo1 = (
  locale?: SupportedLanguages,
): PredictiveReportCandidatePlatformAnalysis => {
  const candidate = makePredictiveReportCandidateFacebookDemo1(locale)

  return {
    uuid: candidate.uuid,
    predictive_report_kol_id: candidate.predictive_report_kol_id,
    name: candidate.name,
    collaborative_items: candidate.collaborative_items,
    kpi: {
      estimated_like_count: 476,
      estimated_comment_count: 15,
      estimated_share_count: 12,
      estimated_view_count: 7158,
      estimated_engagement_count: 503,
      estimated_reach_count: 5202,
      estimated_click_count: 0,
      estimated_avg_view_rate: 0.9760021816198527,
      estimated_reach_rate: 0.7092991546223071,
      estimated_engagement_rate: 0.0685846741205345,
    },
  }
}

export const makePredictiveReportCandidatePlatformAnalysisFacebookDemo2 = (
  locale?: SupportedLanguages,
): PredictiveReportCandidatePlatformAnalysis => {
  const candidate = makePredictiveReportCandidateFacebookDemo2(locale)

  return {
    uuid: candidate.uuid,
    predictive_report_kol_id: candidate.predictive_report_kol_id,
    name: candidate.name,
    collaborative_items: candidate.collaborative_items,
    kpi: {
      estimated_like_count: 294,
      estimated_comment_count: 6,
      estimated_share_count: 8,
      estimated_view_count: 56403,
      estimated_engagement_count: 308,
      estimated_reach_count: 707,
      estimated_click_count: 0,
      estimated_avg_view_rate: 2.530871399084627,
      estimated_reach_rate: 0.03172395225702235,
      estimated_engagement_rate: 0.013820335636722606,
    },
  }
}

export const makePredictiveReportCandidatePlatformAnalysisYoutubeDemo1 = (
  locale?: SupportedLanguages,
): PredictiveReportCandidatePlatformAnalysis => {
  const candidate = makePredictiveReportCandidateYoutubeDemo1(locale)

  return {
    uuid: candidate.uuid,
    predictive_report_kol_id: candidate.predictive_report_kol_id,
    name: candidate.name,
    collaborative_items: candidate.collaborative_items,
    kpi: {
      estimated_like_count: 862,
      estimated_comment_count: 240,
      estimated_share_count: 0,
      estimated_view_count: 38968,
      estimated_engagement_count: 1103,
      estimated_reach_count: 502302,
      estimated_click_count: 0,
      estimated_avg_view_rate: 0.12946179401993355,
      estimated_reach_rate: 1.6687774086378737,
      estimated_engagement_rate: 0.003664451827242525,
    },
  }
}

export const makePredictiveReportDetailReportKolsInstagramDemo = (
  locale?: SupportedLanguages,
): PredictiveReportDetailReportKolsResponse => {
  const candidateList = [
    makePredictiveReportCandidatePlatformAnalysisInstagramDemo1(locale),
    makePredictiveReportCandidatePlatformAnalysisInstagramDemo2(locale),
    makePredictiveReportCandidatePlatformAnalysisInstagramDemo3(locale),
  ]

  return {
    data: candidateList,
    total: candidateList.length,
    page: 1,
    per_page: 10,
    total_page: 1,
  }
}

export const makePredictiveReportDetailReportKolsFacebookDemo = (
  locale?: SupportedLanguages,
): PredictiveReportDetailReportKolsResponse => {
  const candidateList = [
    makePredictiveReportCandidatePlatformAnalysisFacebookDemo1(locale),
    makePredictiveReportCandidatePlatformAnalysisFacebookDemo2(locale),
  ]

  return {
    data: candidateList,
    total: candidateList.length,
    page: 1,
    per_page: 10,
    total_page: 1,
  }
}

export const makePredictiveReportDetailReportKolsYoutubeDemo = (
  locale?: SupportedLanguages,
): PredictiveReportDetailReportKolsResponse => {
  const candidateList = [
    makePredictiveReportCandidatePlatformAnalysisYoutubeDemo1(locale),
  ]

  return {
    data: candidateList,
    total: candidateList.length,
    page: 1,
    per_page: 10,
    total_page: 1,
  }
}

const PREDICTIVE_REPORT_DETAIL_REPORT_KOLS_CUSTOM_DEMO = {
  data: [],
  total: 0,
  page: 1,
  per_page: 10,
  total_page: 1,
}

const predictiveReportDemo = PREDICTIVE_REPORT_DEMO
const predictiveReportConfigDemo = PREDICTIVE_REPORT_CONFIG_DEMO
const predictiveReportSubtotalDemo = PREDICTIVE_REPORT_SUBTOTAL_DEMO

const predictiveReportDetailReportPlatformSubtotalInstagramDemo =
  PREDICTIVE_REPORT_DETAIL_REPORT_PLATFORM_SUBTOTAL_INSTAGRAM_DEMO
const predictiveReportDetailReportPlatformSubtotalFacebookDemo =
  PREDICTIVE_REPORT_DETAIL_REPORT_PLATFORM_SUBTOTAL_FACEBOOK_DEMO
const predictiveReportDetailReportPlatformSubtotalYoutubeDemo =
  PREDICTIVE_REPORT_DETAIL_REPORT_PLATFORM_SUBTOTAL_YOUTUBE_DEMO
const predictiveReportDetailReportPlatformSubtotalCustomDemo =
  PREDICTIVE_REPORT_DETAIL_REPORT_PLATFORM_SUBTOTAL_CUSTOM_DEMO

const predictiveReportDetailReportKolsCustomDemo =
  PREDICTIVE_REPORT_DETAIL_REPORT_KOLS_CUSTOM_DEMO

export {
  predictiveReportConfigDemo,
  predictiveReportDemo,
  predictiveReportDetailReportKolsCustomDemo,
  predictiveReportDetailReportPlatformSubtotalCustomDemo,
  predictiveReportDetailReportPlatformSubtotalFacebookDemo,
  predictiveReportDetailReportPlatformSubtotalInstagramDemo,
  predictiveReportDetailReportPlatformSubtotalYoutubeDemo,
  predictiveReportSubtotalDemo,
}
